/** @jsx jsx */
import { jsx } from "@emotion/react";
import { CSSProperties, FC, ReactNode, useEffect, useRef } from "react";
import { LIST_PADDING } from "./VirtualListbox";

export type Props = {
  style: CSSProperties;
  setSize: (size: number) => void;
  content: ReactNode;
};

const getElementHeight = (el: HTMLElement) => el.getBoundingClientRect().height;

const addPaddingToStyle = (style: CSSProperties) => ({
  ...style,
  top: (style.top as number) + LIST_PADDING,
});

const VirtualListboxRow: FC<Props> = ({ style, setSize, content }) => {
  // Do measurerElementu vykreslim obsah, změřim jeho velikost a pak ji
  // do mapy, odtud se přiřadí parentovi
  const measurerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (measurerRef.current) {
      setSize(getElementHeight(measurerRef.current));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={addPaddingToStyle(style)}>
      <div ref={measurerRef}>{content}</div>
    </div>
  );
};

export default VirtualListboxRow;
export type VirtualListboxRowProps = Props;
